import { SiteClient } from '@/../client-generator/generated-clients/sites';
import axiosInstance from '../utilities/axios-instance';

const sitesClient = new SiteClient('', axiosInstance as any);

export default sitesClient;
